import React, { memo } from 'react';
import { SortableElement } from 'react-sortable-hoc';
import uniqueId from '../../utils/uniqueId';

const SortableItem = Component => {
  const WrappedComponent = SortableElement(Component);

  const Composed = props => {
    const id = uniqueId();

    return <WrappedComponent id={id} {...props} />;
  };

  Composed.displayName = `SortableItem(${Component.displayName || Component.name || 'Component'})`;

  return memo(Composed);
};

export { SortableItem };
